import $ from 'jquery';
import 'daterangepicker';
import moment from 'moment';

moment.locale('el');

const locale = {
    format: 'DD/MM/YYYY HH:mm',
    separator: ' - ',
    applyLabel: "Εφαρμογή",
    cancelLabel: "Ακύρωση",
    fromLabel: "From",
    toLabel: "To",
    customRangeLabel: "Custom",
    daysOfWeek: [
        "Κυρ",
        "Δε",
        "Τρ",
        "Τετ",
        "Πε",
        "Παρ",
        "Σαβ"
    ],
    monthNames: [
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος"
    ],
    firstDay: 1
};

$(() => {
    $('.js-datetimepicker').daterangepicker({
        showDropdowns: true,
        timePicker: true,
        timePicker24Hour: true,
        singleDatePicker: true,
        locale: { ...locale, format: 'DD/MM/YYYY HH:mm' },
        autoUpdateInput: false,
    }).on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format(picker.locale.format));
    }).on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    $('.js-datepicker').daterangepicker({
        showDropdowns: true,
        timePicker: false,
        timePicker24Hour: false,
        singleDatePicker: true,
        locale: { ...locale, format: 'DD/MM/YYYY' },
        autoUpdateInput: false,
    }).on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format(picker.locale.format));
    }).on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
});
